import { FC } from 'react';

import { useInitTracker } from '../../../hooks/tracker/use-init-tracker';
import { usePlayerAnalytics } from '../../../hooks/tracker/use-player-analytics';
import { useMovieTrailerCurrentStream } from '../../../../movie-trailer-player/hooks/use-movie-trailer-current-stream';
import { getStreamsTrackingData } from '../../../utils/get-streams-tracking-data';

interface Props {
    contentId: string;
    psid: string;
}

export const TrailerPlayerTracker: FC<Props> = ({ contentId, psid }) => {
    const currentStream = useMovieTrailerCurrentStream(contentId);

    useInitTracker({
        contentId,
        streamTrackingData: getStreamsTrackingData(currentStream?.streamMeta?.trackings),
    });
    usePlayerAnalytics({
        contentId,
        psid,
        manifestUrl: currentStream?.uri,
    });

    return null;
};
